/**
 * Copyright 2015-present Version1. All Rights Reserved.
 *
 */
import { getItemFromSessionStorage, makeRequest } from '../../helpers';

const basePath = process.env.REACT_APP_API_ENDPOINT || '/';

export const getInsuranceType = async (policyReference, cognitoAccessTokenKey, props = {}) => {
  const authToken = getItemFromSessionStorage(cognitoAccessTokenKey) || '';
  return await makeRequest({
    method: 'GET',
    url: `${basePath}/home/home_quotes/insurance/${policyReference}`,
    authToken: authToken,
    history: props.history
  });
};
